import AmenitiesChipEditor from '../../../../components/AmenitiesChipEditor/AmenitiesChipEditor';
import { isBulkDraftListing } from '../drawerEditHelpers';
import BulkAmenitiesSection from './BulkAmenitiesSection';

function resolveAmenities(listing, dirtyFields) {
    if (dirtyFields?.amenities) return dirtyFields.amenities;
    const confirmed = listing.confirmedFields?.amenities;
    if (Array.isArray(confirmed) && confirmed.length) return confirmed;
    const enriched = listing.enrichmentFields?.amenities;
    if (Array.isArray(enriched)) return enriched.map((a) => a?.slug || a?.name || a).filter(Boolean);
    return [];
}

function resolveAiSuggested(listing) {
    const enriched = listing.enrichmentFields?.amenities;
    if (!Array.isArray(enriched)) return [];
    return enriched.map((a) => a?.slug).filter(Boolean);
}

export default function AmenitiesSection(props) {
    const { listing, editMode = false, dirtyFields, setDirtyFields, onRequestEdit } = props;

    if (isBulkDraftListing(listing)) {
        return <BulkAmenitiesSection {...props} />;
    }

    const amenities = resolveAmenities(listing, editMode ? dirtyFields : null);
    const aiSuggested = resolveAiSuggested(listing);

    if (!editMode) {
        if (!amenities.length) {
            return (
                <div className="host-panel-section">
                    <div className="host-panel-section-header">
                        <div className="host-panel-section-label">Amenities</div>
                        {onRequestEdit && (
                            <button
                                type="button"
                                className="host-section-edit-link"
                                onClick={onRequestEdit}
                            >
                                Edit →
                            </button>
                        )}
                    </div>
                    <p className="drawer-empty-note">No amenities added yet</p>
                </div>
            );
        }
        return (
            <div className="host-panel-section">
                <AmenitiesChipEditor
                    value={amenities}
                    aiSuggested={aiSuggested}
                    disabled
                />
            </div>
        );
    }

    return (
        <div className="host-panel-section">
            <AmenitiesChipEditor
                value={amenities}
                aiSuggested={aiSuggested}
                onChange={(slugs) => setDirtyFields((prev) => ({ ...prev, amenities: slugs }))}
            />
        </div>
    );
}
